import { useDevice } from '@/hooks/use-device';
import style from './header.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function Header() {
  const { isMobile } = useDevice();
  return (
    <div className={style.header}>
      <h1 className={style.title}>World of Viking Map</h1>
      <h2 className={style.subtitle}>
        Explore the interactive map below to discover the exciting world of Viking destinations. The itineraries listed
        {isMobile ? ' below' : ' on the right'} will give you all the details you need for your journey.
      </h2>
    </div>
  );
}
